<template>
  <div id="app">
    <app-header v-if="showHeader" style="flex-shrink: 0;"></app-header>
    <div class="app-content">
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </div>
    <app-footer></app-footer>
  </div>
</template>
<script>

import AppHeader from '@/views/layout/header.vue';
import AppFooter from '@/views/layout/footer.vue';

export default {
  components: {
    AppHeader,
    AppFooter,
  },
  data() {
    return {
      showHeader: false,
    };
  },
  created() {
    this.setShowHeader(this.$route);
  },
  watch: {
    $route: 'setShowHeader',
  },
  methods: {
    setShowHeader(rt) {
      const showParam = (rt.meta || {}).showHeader;
      this.showHeader = (showParam === null
        || typeof (showParam) === 'undefined') ? true : Boolean(showParam);
    },
  },
};
</script>

<style lang="scss">
  @import '~@/theme/app.scss';

  html, body {
    margin: 0px;
    padding: 0px;
    width: 100%;
    height: 100%;
    min-width: 1024px;
    min-height: 768px;
    font-family:"Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB",
    "Microsoft YaHei","微软雅黑",Arial,sans-serif;
    font-size: 16px;
    box-sizing: border-box;
    // overflow: hidden;
  }

  #app {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background-color: $app-backgroud-color;
    // position: relative;
  }
  .app-content {
    padding-left: 2rem;
    padding-right: 2rem;
    flex: 1;
    display: flex;
    background-color: $app-backgroud-color;
    > div {
      width: 100%;
    }
  }

</style>
